
import { defaultFontSetting,  defaultPaddingSetting, defaultBorderRadiusSetting, defaultBoxShadowSetting, defaultIconSetting} from '../setting/defaultSetting'
export const props = [
  {
    name: "secondNavTitle",
    desc: "标题",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondNavActiveTitle",
    desc: "标题",
    isSystem: true,
    group: "选中",
    categoryName: "二级导航",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondActiveNavTitleBackground",
    desc: "背景",
    isSystem: true,
    group: "选中",
    categoryName: "二级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 1)",
      isThemeColor: false
    }]
  },
  {
    name: "secondNavTitleActiveBorder",
    desc: "边框",
    isSystem: true,
    group: "选中",
    type: "borderSet",
    categoryName: "二级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondNavHoverTitle",
    desc: "标题",
    isSystem: true,
    group: "悬浮",
    categoryName: "二级导航",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondHoverNavTitleBackground",
    desc: "背景",
    isSystem: true,
    group: "悬浮",
    categoryName: "二级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 1)",
      isThemeColor: false
    }]
  },
  {
    name: "secondNavTitleHoverBorder",
    desc: "边框",
    isSystem: true,
    group: "悬浮",
    type: "borderSet",
    categoryName: "二级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondNavTitleBackground",
    desc: "背景",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 1)",
      isThemeColor: false
    }]
  },
  {
    name: "secondNavIcon",
    desc: "图标",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting,
    }
  },
  {
    name: "secondNavTitleBorder",
    desc: "标题边框",
    isSystem: true,
    group: "默认",
    type: "borderSet",
    categoryName: "二级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondNavPadding",
    desc: "边距",
    isSystem: true,
    group: "默认",
    type: "paddingSet",
    categoryName: "二级导航",
    defaultValue: {
      ...defaultPaddingSetting,
      paddingTypeFlag: 2,
      paddingBottom: 12,
      paddingLeft: 8,
      paddingRight: 24,
    }
  },
  {
    name: "secondRadius",
    desc: "圆角",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "secondNavActivePadding",
    desc: "边距",
    isSystem: true,
    group: "选中",
    type: "paddingSet",
    categoryName: "二级导航",
    defaultValue: {
      ...defaultPaddingSetting,
      paddingTypeFlag: 2,
      paddingBottom: 12,
      paddingLeft: 8,
      paddingRight: 24,
    }
  },
  {
    name: "secondNavHoverPadding",
    desc: "边距",
    isSystem: true,
    group: "悬浮",
    type: "paddingSet",
    categoryName: "二级导航",
    defaultValue: {
      ...defaultPaddingSetting,
      paddingTypeFlag: 2,
      paddingBottom: 12,
      paddingLeft: 8,
      paddingRight: 24,
    }
  },
  {
    name: "secondActiveRadius",
    desc: "圆角",
    isSystem: true,
    group: "选中",
    categoryName: "二级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "secondHoverRadius",
    desc: "圆角",
    isSystem: true,
    group: "悬浮",
    categoryName: "二级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "secondTitleBorderWidth",
    desc: "粗细",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "numberSet",
    defaultValue: 2,
    unit: 'px'
  },
  {
    name: "secondTitleBorderColor",
    desc: "颜色",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "colorSet",
    defaultValue: {
      type: 'color',
      color: 'rgba(10, 107, 255, 1)',
      data: {
        angle: 0,
        stops: [
          ['rgba(10, 107, 255, 1)', 0],
          ['rgba(10, 107, 255, 1)', 1]
        ]
      }
    },
  },
  {
    name: 'widthType',
    desc: '宽度',
    type: 'sliderSet',
    group: "默认",
    categoryName: "三级导航",
    extraConfig: {
      options: [{
        title: '固定',
        value: 'fixed'
      }, {
        title: '均分',
        value: 'equal'
      }]
    },
    defaultValue: 'fixed'
  },
  {
    name: 'widthValue',
    desc: '',
    type: 'numberSet',
    group: "默认",
    categoryName: "三级导航",
    defaultValue: 145,
    unit: 'px',
    extraConfig: {
      styleId: 1,
      hideTitle: true,
      hideSlider: true,
      suffix: 'px',
      inputWidth: 168,
      sliderMax: 500
    }
  },
  {
    name: "thirdNavTitle",
    desc: "标题",
    isSystem: true,
    type: "fontSet",
    group: "默认",
    categoryName: "三级导航",
    defaultValue: {
      ...defaultFontSetting,
      fontSize: 14,
      lineHeight: 40,
      fontWeight: 400,
      fontColor: "rgba(13, 12, 34, 1)"
    }
  },
  {
    name: "thirdNavIcon",
    desc: "图标",
    isSystem: true,
    group: "默认",
    categoryName: "三级导航",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting,
    }
  },
  {
    name: "thirdNavTitleLines",
    desc: "最大标题行数",
    isSystem: true,
    group: "默认",
    categoryName: "三级导航",
    type: "numberSet",
    defaultValue: 1,
    extraConfig: {
      sliderMin: 1,
      hideTitle: true
    }
  },
  {
    name: "thirdNavTitleMargin",
    desc: "行间距",
    isSystem: true,
    group: "默认",
    categoryName: "三级导航",
    type: "numberSet",
    defaultValue: 0,
    unit: 'px',
    extraConfig: {
      suffix: "px",
      hideTitle: true
    }
  },
  {
    name: "thirdNavPadding",
    desc: "边距",
    isSystem: true,
    group: "默认",
    categoryName: "三级导航",
    type: "paddingSet",
    defaultValue: {
      ...defaultPaddingSetting,
      paddingTypeFlag: 2,
      paddingRight: 10,
      paddingLeft: 10,
    }
  },
  {
    name: "thirdTitleRadius",
    desc: "圆角",
    isSystem: true,
    group: "默认",
    categoryName: "三级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "thirdTitleBorder",
    desc: "边框",
    isSystem: true,
    group: "默认",
    type: "borderSet",
    categoryName: "三级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(255, 255, 255, 0)"
    }
  },
  {
    name: "thirdNavTitleBackground",
    desc: "标题背景",
    isSystem: true,
    group: "默认",
    categoryName: "三级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 0)",
      isThemeColor: false
    }]
  },
  {
    name: "thirdActiveNavTitle",
    desc: "标题",
    isSystem: true,
    group: "选中",
    categoryName: "三级导航",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontSize: 14,
      fontWeight: 400,
      fontColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdHoverNavTitle",
    desc: "标题",
    isSystem: true,
    group: "悬浮",
    categoryName: "三级导航",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontSize: 14,
      fontWeight: 400,
      fontColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdActiveRadius",
    desc: "圆角",
    isSystem: true,
    group: "选中",
    categoryName: "三级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "thirdHoverRadius",
    desc: "圆角",
    isSystem: true,
    group: "悬浮",
    categoryName: "三级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "thirdTitleActiveBorder",
    desc: "边框",
    isSystem: true,
    group: "选中",
    type: "borderSet",
    categoryName: "三级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdTitleHoverBorder",
    desc: "边框",
    isSystem: true,
    group: "悬浮",
    type: "borderSet",
    categoryName: "三级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdActiveNavTitleBackground",
    desc: "标题背景",
    isSystem: true,
    group: "选中",
    categoryName: "三级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(242, 243, 245, 1)",
      isThemeColor: false
    }]
  },
  {
    name: "thirdHoverNavTitleBackground",
    desc: "标题背景",
    isSystem: true,
    group: "悬浮",
    categoryName: "三级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(242, 243, 245, 1)",
      isThemeColor: false
    }]
  },
  {
    name: "navPopPosition",
    desc: "对齐",
    group: "默认",
    categoryName: "菜单列表",
    type: "sliderSet",
    defaultValue: 'left',
    extraConfig: {
      showToolTip: true,
      options: [{
        iconClass: 'icon-portal-Align-left',
        label: '左对齐',
        value: 'left'
      }, {
        iconClass: 'icon-portal-Center-lr',
        label: '居中对齐',
        value: 'center',
      }, {
        iconClass: 'icon-portal-Align-right',
        label: '右对齐',
        value: 'right'
      }]
    }
    
  },
  {
    name: "navSite",
    desc: "排列",
    group: "默认",
    categoryName: "菜单列表",
    type: "cxSite",
    defaultValue: {
      alignmentType: "center"
    }
  },
  {
    name: "navSize",
    desc: "尺寸",
    group: "默认",
    categoryName: "菜单列表",
    type: "sizeSet",
    defaultValue: {
      widthVal: 500,
      heightVal: 300,
      widthAuto: true,
      heightAuto: true,
      widthFull: false,
      widthCenter: false,
      showFullCenter: true
    }
  },
  {
    name: "wholeBackground",
    desc: "背景",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "backgroundSet",
    defaultValue: [
      {
        type: "color",
        color: "#fff",
        isThemeColor: false
      }
    ]
  },
  {
    name: "navBorder",
    desc: "边框",
    isSystem: true,
    group: "默认",
    type: "borderSet",
    categoryName: "菜单列表",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "navPadding",
    desc: "边距",
    isSystem: true,
    group: "默认",
    type: "paddingSet",
    categoryName: "菜单列表",
    defaultValue: {
      ...defaultPaddingSetting,
      padding: 10
    }
  },
  {
    name: "navBorderRadius",
    desc: "圆角",
    isSystem: true,
    group: "默认",
    type: "radiusSet",
    categoryName: "菜单列表",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "showConnector",
    desc: "显示连接符",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "booleanSet",
    defaultValue: false,
  },
  {
    name: "navBoxShadow",
    desc: "阴影",
    isSystem: true,
    categoryName: "菜单列表",
    group: "默认",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "navGap",
    desc: "列间距",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "numberSet",
    defaultValue: 10,
    unit: 'px'
  },
  {
    name: "showConnector",
    desc: "显示连接符",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "booleanSet",
    defaultValue: false,
  },
  {
    name: "connectorColor",
    desc: "颜色",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "colorSet",
    defaultValue: {
      type: 'color',
      color: 'rgba(10, 107, 255, 1)',
      isThemeColor: true,
      data: {
        angle: 0,
        stops: [
          ['rgba(10, 107, 255, 1)', 0],
          ['rgba(10, 107, 255, 1)', 1]
        ]
      }
    },
  },
  {
    name: "connectorWidth",
    desc: "粗细",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "numberSet",
    defaultValue: 0,
    extraConfig: {
      suffix: 'px'
    },
    unit: 'px'
  },
]

export default props
